// FI-2114: shared body-level portal for vue-bootstrap-datetimepicker widgets.
//
// The picker inserts its calendar as an absolutely-positioned sibling of the
// input. Every Driver Manager page keeps its date fields inside
// `.dsd-date-fields`, which was `display: none` until a "Custom" chip was
// clicked (the fields are always visible since FI-2229), so the widget's
// position got computed against a collapsed, unpositioned ancestor and the
// calendar landed at the bottom of the page.
//
// Pointing the picker at a positioned div on <body> fixes it. driver_manager_compare.vue
// had this privately; the other five Driver Manager pages did not, which is why
// only Compare positioned correctly. Lifted here so there is one copy.
//
// Usage: register the mixin (it owns the portal's lifecycle on its own) and set
//   widgetParent: DTPICKER_WIDGET_PARENT
// on each picker's config object.

export const DTPICKER_PORTAL_ID = 'scorecard-dtpicker-portal'
export const DTPICKER_WIDGET_PARENT = '#' + DTPICKER_PORTAL_ID

// Router transitions can hold the outgoing and incoming page in the DOM at the
// same time, so the portal is refcounted: the first page in creates it, the last
// one out removes it. Without this the outgoing page's beforeDestroy would yank
// the portal the incoming page had just claimed.
let portalUsers = 0

export default {
  created() {
    this._ensureDtPickerPortal()
  },

  beforeDestroy() {
    this._releaseDtPickerPortal()
  },

  methods: {
    _ensureDtPickerPortal() {
      portalUsers += 1
      if (document.getElementById(DTPICKER_PORTAL_ID)) return
      const el = document.createElement('div')
      el.id = DTPICKER_PORTAL_ID
      Object.assign(el.style, {
        position: 'absolute', top: '0', left: '0',
        width: '0', height: '0', overflow: 'visible', zIndex: '9999',
      })
      document.body.appendChild(el)
    },

    _releaseDtPickerPortal() {
      portalUsers = Math.max(0, portalUsers - 1)
      if (portalUsers > 0) return
      const el = document.getElementById(DTPICKER_PORTAL_ID)
      if (el) el.remove()
    },
  },
}
